import { useEffect, } from "react";
import { BzTabsContainer } from '../../components';
import OptionValue from '../Calculators/OptionValue';
import FutureFairValue from '../Calculators/FutureFairValue';
import SpanMargin from '../Calculators/SpanMargin';
import PivotPoint from '../Calculators/PivotPoint';
import Fibonacci from '../Calculators/Fibonacci';
import { useDispatch } from "react-redux";
import { resetSearchData } from "../../redux/actions/globalSearch";

// ---BT-107433_SrikanthRao_9-10-2023_Calculator || Functional Implementation

const MainCalcuator = ({ activeTab, ...props }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resetSearchData());

    }
        , [activeTab, dispatch]);
    return (
        <>
            <BzTabsContainer>
                {
                    activeTab === 'option_value' ? <OptionValue {...props} />
                        :
                        activeTab === 'fair_value' ? <FutureFairValue {...props} />
                            :
                            activeTab === 'span_margin' ? <SpanMargin {...props} />
                                :
                                activeTab === 'pivot_point' ? <PivotPoint {...props} />
                                    :
                                    activeTab === 'fibonacci' ? <Fibonacci {...props} />
                                        : null
                }

            </BzTabsContainer>
        </>
    );
};


export default MainCalcuator;